import axios from 'axios';
import config from '@/config';
import { message } from 'ant-design-vue';
import { tokenManager } from '@/util/token';
import { retrocycle } from '@/util/json';
import { toLogin } from '@/util/login';
import { useFileSystemAccess } from '@vueuse/core';

const instance = axios.create({
  baseURL: config.apiPath,
});

export async function postForm(
  path: string,
  data: Record<string, string | File>
) {
  const form = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    form.append(key, value);
  });
  return request(path, form);
}

interface ErrorParam {
  type: 'biz' | 'network' | 'unknown';
  error: any;
  message: string;
}

export async function request(
  path: string,
  data?: any,
  options?: {
    noNeedLogin?: boolean;
    onError?: (error: ErrorParam) => void | boolean;
  }
) {
  const onError = (error: ErrorParam) => {
    if (!options?.onError || options.onError(error) !== true) {
      message.error(error.message);
    }
  };
  const token = tokenManager.get();
  if (!options?.noNeedLogin && !token) {
    await toLogin();
    return;
  }
  try {
    const res = await instance.post(path, data, {
      headers: {
        ...token,
      },
    });
    const resData = retrocycle(res.data);
    if (resData.error) {
      onError({ type: 'biz', error: resData, message: resData.message });
      if (resData.error === 'IdentificationException') {
        await toLogin();
        return;
      }
    } else {
      return resData.data;
    }
  } catch (error) {
    /**
     * 请求错误
     * 超时重试
     * 点击重试
     */
    if (error instanceof Error && error.message === 'Network Error') {
      message.error('连接服务器失败');
      onError({ type: 'network', error, message: '连接服务器失败' });
    } else {
      onError({ type: 'unknown', error, message: '请求失败' });
      message.error('请求失败');
    }
  }
}

export function crudPath(
  moduleName: string,
  controllerName: string,
  actionName: string
) {
  return '/' + moduleName + '/' + controllerName + '/' + actionName;
}

export async function uploadImg() {
  const img = await picImg();
  if (img && !(img instanceof Array)) {
    const res = await postForm(config.uploadApiPath, { file: img });
    if (res) {
      return config.uploadPath + res.path;
    }
  }
}

async function picImg(): Promise<File | undefined | File[]> {
  const { file, open } = useFileSystemAccess({});
  try {
    await open({
      types: [
        {
          description: 'Images',
          accept: {
            'image/*': ['.png', '.gif', '.jpeg', '.jpg'],
          },
        },
      ],
    });
  } catch (e) {
    console.log(e);
    return undefined;
  }
  return file.value;
}
